import BaseApi from '@/api/Base/BaseApi'

export default class AINodeApi extends BaseApi {
  getAINodeList() {
    return this.agent.get<any>('/admin/ai-node/online-list')
  }

  updateHyperparameters() {
    return this.agent.post<any>('/admin/hyperparameter')
  }

  getDefaultParameters() {
    return this.agent.get<any>('/admin/hyperparameters')
  }
}
